// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Tz","pending":"e_Uz","slider":"e_Vz","imageContainer":"e_Wz","image":"e_Xz","button":"e_Yz","prevButton":"e_Zz","nextButton":"e__z","disabled":"e_0z"};